import Vue from 'vue';
import Card from '@/components/Utils/Card.vue';
import Row from '@/components/Utils/Row.vue';
import Row2 from '@/components/Utils/Row2.vue';
import Space from '@/components/Utils/Space.vue';
import ActionBtn from '@/components/Utils/ActionBtn.vue';

Vue.component('card', Card);
Vue.component('row', Row);
Vue.component('row2', Row2);
Vue.component('space', Space);
Vue.component('action-btn', ActionBtn);
